import { useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';

import { Button, HelperTooltip } from 'components';

import style from './index.module.scss';
import cx from 'clsx';

export const AnalysisModeButton = ({
  address,
  onEnter,
  className,
}: {
  address: string;
  onEnter: () => void;
  className?: string;
}) => {
  const { t } = useTranslation();

  const handleDownloadClick = useCallback(async () => {
    onEnter();
  }, [onEnter]);

  return (
    <div className={cx(style.container, className)}>
      <HelperTooltip title={t('AnalysisModeButton.19nbi4v')}>
        <Button className={cx(style.textButton)} onClick={handleDownloadClick} type="text">
          {t('AnalysisModeButton.dtxzgb')}
        </Button>
      </HelperTooltip>
      <Button className={cx(style.button)} onClick={handleDownloadClick}>
        {t('AnalysisModeButton.13hiqnb')}
      </Button>
    </div>
  );
};
